<template>

    <main class="antialiased scroll-smooth selection:bg-secondary-200 selection:text-neutral-800">
        
        <NavigationBlock />

        <HeroBlock :content="heroContent" />

        <TimetableBlock :content="timetableContent" />

        <ContactBlock :content="contactContent" />

        <IconBlock :content="iconContent" />
        
        <FeatureBlock :content="featureContent" />

        <FooterBlock />
        
    </main>

</template>

<script>

    // Import Components
    import NavigationBlock from './blocks/Nav'
    import HeroBlock from './blocks/Hero'
    import TimetableBlock from './blocks/Timetable'
    import ContactBlock from './blocks/Contact'
    import IconBlock from './blocks/Icon'
    import FeatureBlock from './blocks/Feature'
    import FooterBlock from './blocks/Footer'
    
    // Export App
    export default {

        name: 'App',

        components: {
            NavigationBlock,
            HeroBlock,
            TimetableBlock,
            ContactBlock,
            IconBlock,
            FeatureBlock,
            FooterBlock
        },

        data(){
            return {

                heroContent: {
                    block_id: "Hero",
                    byline: "Fresh food, the Latin way",
                    headline: "Authentic, Fresh, ",
                    headlineAccent: "Homemade",
                    copy: "We want to bring the best of Latin American food to the streets of Aberdeen and share the flavours that define our culture. Taste the best of our cuisine, from Argentina, to Mexico, to Venezuela and beyond.",
                    cta_secondary: {
                        url: "../../files/menu.pdf",
                        text: "View Menu →",
                    },
                    cta_primary: {
                        url: "https://goodeats.io/LATINWAY",
                        text: "Order Now",
                    },
                    hero_pictures: [
                        { title: "Tacos", rotation: "rotate-2", file: [require("@/assets/pictures/hero/tacos.webp")], index: 0 },
                        { title: "Table", rotation: "-rotate-3", file: [require("@/assets/pictures/hero/table.webp")], index: 1 },
                        { title: "Tequenos", rotation: "rotate-3", file: [require("@/assets/pictures/hero/teques.webp")], index: 2 },
                    ]
                },

                timetableContent: {
                    block_id: 'Timetable',
                    headline: "Opening Times",
                    copy: "Taste the bold flavors of Latin America in Aberdeen. Open daily with weekend hours.",
                    times: [
                        { day: "Monday", hours: "Closed" },
                        { day: "Tuesday", hours: "12:00 - 19:00" },
                        { day: "Wednesday", hours: "12:00 - 19:00" },
                        { day: "Thursday", hours: "12:00 - 19:00" },
                        { day: "Friday", hours: "12:00 - 21:00" },
                        { day: "Saturday", hours: "12:00 - 21:00" },
                        { day: "Sunday", hours: "17:00 - 21:00" },
                    ],
                },

                contactContent: {
                    block_id: "Contact",
                    headline: "Get in Touch",
                    copy: [
                        "Want to book Latinway for an event?",
                        "Fancy getting food delivered to the office?",
                        "Need to know about food restrictions?",
                        "Sending us your CV for a job?",
                    ],
                    cta: {
                        url: "../../files/menu.pdf",
                        text: "View Menu →"
                    },
                    image: {
                        alt: "Segundo and Ana María",
                        file: [require("@/assets/pictures/segu_ana.webp")],
                    }
                },

                iconContent: {
                    block_id: "Order",
                    headline: "How to Order",
                    copy: "Discover authentic Latin American flavours with ease - choose from ordering for collection, delivery, or catering, all available through our website!",
                    cards: [
                        {  
                            title: "Collection",
                            icon: [require("@/assets/icons/latam.webp")],
                            copy: "Place your order online and skip the line! Make your order and come by to collect your meal, without the wait.",
                            cta: {
                                text: "Order to Collect →",
                                url: "https://goodeats.io/LATINWAY/" 
                                } 
                            },
                        {
                            title: "Delivery",
                            icon: [require("@/assets/icons/llama.webp")],
                            copy: "Can't make it to us? No problem! Order online  and we'll bring the deliciousness right to your door, no hassle.",
                            cta: {
                                text: "Get Delivered →",
                                url: "https://goodeats.io/LATINWAY/"
                            }
                        },
                        {
                            title: "Catering",
                            icon: [require("@/assets/icons/cactus.webp")],
                            copy: "From corporate events to weddings, let us make your next event a hit with the perfect food for the occasion.",
                            cta: {
                                text: "Get in Touch →",
                                url: "https://goodeats.io/LATINWAY/"
                            }
                        },
                    ]
                },
                
                featureContent: {
                    block_id:"About",
                    byline: "About Us",
                    headline: "So what is Latinway?",
                    copy: [
                        "We want to bring the best of Latin American food to the streets of Aberdeen and share the flavours that define our culture. Taste the best of our cuisine, from Argentina, to Mexico, Venezuela and beyond.",
                        "Our menu is a celebration of cultural diversity and a nod to traditional recipes. Join us on a flavour journey and taste the difference of authentic, homemade cuisine."
                    ],
                    cta: {
                        url: "../../files/menu.pdf",
                        text: "View Menu →"
                    },
                    image: {
                        alt: "Segundo and Ana María",
                        file: [require("@/assets/pictures/segu_ana.webp")],
                    }
                }

            }
        }
    }

</script>